import undoable from 'redux-undo';
import {
  TAC_ADD_ITEM,
  TAC_ADD_MULTIPLE,
  TAC_REMOVE_ITEM,
  TAC_UPDATE_ITEM,
  TAC_UPDATE_MULTIPLE,
  TAC_LOAD,
  TAC_HIDE_ITEM,
  TAC_SET_WALL,
  TAC_SET_USE_MOUNTING_RAIL,
  POPUPS_SHOW_SCENE_ERRORS,
  TAC_REMOVE_TOAST_FLAGS,
  TAC_SET_TOAST_FLAGS,
  TAC_UPDATE_WALL_SIZE,
} from '../../actionConstants';
import { filterActions } from './filterActions';

const tac = (state = null, action) => {
  switch (action.type) {
    case TAC_SET_TOAST_FLAGS: {
      const toastFlags = action.payload;
      return {
        ...state,
        ...toastFlags,
      };
    }

    case TAC_LOAD:
    case TAC_ADD_ITEM:
    case TAC_ADD_MULTIPLE:
    case TAC_UPDATE_ITEM:
    case TAC_UPDATE_MULTIPLE:
    case TAC_REMOVE_ITEM:
    case TAC_HIDE_ITEM:
    case TAC_SET_WALL: {
      const { model, errors, centerConfiguration = false } = action.payload;

      return model
        ? {
            ...model,
            centerConfiguration,
            errors,
          }
        : state;
    }

    case TAC_SET_USE_MOUNTING_RAIL: {
      if (!state) {
        return null;
      }

      return action.payload.model;
    }

    case POPUPS_SHOW_SCENE_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
      };
    }
    case TAC_REMOVE_TOAST_FLAGS:
      const { toastFlags, ...remainingState } = state;
      return remainingState;

    case TAC_UPDATE_WALL_SIZE:
      return {
        ...state,
        wall: {
          ...state.wall,
          size: {
            ...state.wall.size,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
};

const undoableTac = undoable(tac, {
  filter: filterActions,
  limit: 10,
});

export default undoableTac;
